import { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import I18n from 'I18n';
import { NavMarker } from 'react-rhumb';
import { OrderedSet } from 'immutable';
import { useLocation } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { ListingPage } from 'foundations-components/transitional/components/ListingPage';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { Small } from 'foundations-components/transitional/components/Small';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { Text } from 'foundations-components/components/Text';
import { DynamicFilterIcon } from 'foundations-assets';
import { useGetQuickFilterValue, useListingLibQuickFilters } from 'framework-listing-lib/hooks/useQuickFilters';
import { IN } from 'framework-listing-lib/utils/filters';
import ListingLibFilterWrapper from 'framework-listing-lib/filters/ListingLibFilterWrapper';
import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import AsyncContentAccessControlPanel from 'content-management-actions-lib/modals/AsyncContentAccessControlPanel';
import AsyncPublishingOptionsModal from 'content-management-actions-lib/modals/AsyncPublishingOptionsModal';
import AsyncUnpublishingOptionsModal from 'content-management-actions-lib/modals/AsyncUnpublishingOptionsModal';
import ContentListingTable from 'content-management-listing-lib/components/ContentListingTable';
import ContentQuickFilters from 'content-management-listing-lib/components/ContentQuickFilters';
import ExportDialog from 'ExportDialog/modal/ExportDialog';
import Header from '../../components/HeaderV3';
import UpgradeDowngradeBanner from '../../upgrades/components/UpgradeDowngradeBanner';
import ImportArticlesPanel from '../../containers/importV3/ImportArticlesPanel';
import ImportModal from '../../importV3/containers/ImportModal';
import ArticleTableEmptyState from './ArticleTableEmptyState';
import ArticleCategoryFilter from './ArticleCategoryFilter';
import ProvideReferenceResolvers from 'content-management-listing-lib/provider/ProvideReferenceResolvers';
import ContentListingLibProvider from 'content-management-listing-lib/provider/ContentListingLibProvider';
import ExportClient from '../../api/ExportClient';
import { isInProgress, useSmartCopyProgress } from '../../importV3/hooks/useSmartCopyProgress';
import { useCurrentKnowledgeBaseId } from '../../knowledge-base/hooks/knowledgeBaseHooks';
import useMoreKnowledgeBaseActions from '../hooks/useMoreKnowledgeBaseActions';
import { useHasScope } from 'ContentData/hooks/authHooks';
import { useAppSelector } from '../../utils/hooks';
import { getAuth } from '../../selectors/auth';
import { getUserEmail } from '../../selectors/auth';
import { getUserHasManagePrivateContentAccess } from '../../selectors/scopes';
import { selectCategoriesList } from '../../selectors/categoryOrganizationInfo';
import { selectAuthors } from '../../knowledge-base/selectors/knowledgeBaseDetails';
import { CATEGORY_IDS } from 'ContentUtils/constants/Categories';
import { CONTENT_ACTION_IDS } from 'content-management-actions-lib/constants/actionIds';
import { FilterablePublishStates } from 'content-management-listing-lib/constants/filters';
import { ContentTypes } from 'ui-memberships-settings-lib/constants/ContentTypes';
import { AudienceAccessTypes } from 'ui-memberships-settings-lib/constants/AudienceAccessTypes';
//@ts-expect-error no types
import { setupCsat } from 'wootric-nps/csat/csat-setup';
import { CONTENT_PLATFORM_PROPERTY_NAME, ContentObjectTypes, ContentGroupObjectTypes, Namespaces, getContentPropertyValue } from 'content-management-data-lib';
// @ts-expect-error Untyped module
import In from 'customer-data-filters/filterQueryFormat/operator/In';
// @ts-expect-error Untyped module
import NotIn from 'customer-data-filters/filterQueryFormat/operator/NotIn';
import { ROW_ACTION_GROUPS, VIEW_NAME_ID } from '../constants/actionGroups';
import { CONTACTS_LISTS_ACCESS, CONTACTS_LISTS_READ, SERVICE_CONTENT_RESTRICTED_WRITE, SERVICE_KNOWLEDGE_ARTICLE_PUBLISH_SCOPE, SERVICE_KNOWLEDGE_ARTICLE_WRITE_SCOPE } from '../../constants/ScopesConstants';
import StateConstants from '../../constants/StateConstants';
import { SCREENS } from '../../constants/TrackingConstants';
import { getAudienceAccessPropertyOptions, getContentPublishStatusPropertyOptions } from 'content-management-listing-lib/utils/filterPropertyUtils';
import { getContentAccessControlPanelSaveSuccessNotification, getContentAccessControlPanelSaveFailureNotification } from 'ui-memberships-settings-lib/utils/alerts';
import { getContentAccessControlEditPermissionsDisabledTooltipI18nKey } from 'ui-memberships-settings-lib/utils/tooltips';
import { getContentAccessControlOptions } from '../../utils/articleVisibilityUtils';
import UsageTracker, { usageTrackerForFrameworkListingLib } from '../../utils/UsageTracker';
import { getArticlePerformanceUrl, getEditorUrl } from '../../routing/utils/externalUrls';
import { useHasGate } from '../../auth/hooks/authHooks';
import { gate } from 'hub-http/gates';
import ArticlesCampaignFilter from './ArticlesCampaignFilter';
import { Select } from 'foundations-components/transitional/components/Select';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ProvideContentReferenceResolvers = ProvideReferenceResolvers();

//TODO: review filters validation
const filterValidationConfig = {
  isFilterAvailableForUser: filter => filter.property !== 'hs_all_assigned_business_unit_ids'
};
const getCustomPropertyLabel = propertyName => I18n.text(`knowledgeContentUI.properties.labels.${propertyName}`);
const onSuccess = () => {
  FloatingAlertStore.addAlert({
    message: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "knowledgeContentUI.export.exportSuccess.message"
    }),
    titleText: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "knowledgeContentUI.export.exportSuccess.title"
    }),
    type: 'success'
  });
  UsageTracker.track('manageArticleInteraction', {
    screen: 'manage-articles',
    action: 'submit-export-articles'
  });
};
const onFailure = () => FloatingAlertStore.addAlert({
  message: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "knowledgeContentUI.export.exportFailed.message"
  }),
  titleText: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "knowledgeContentUI.export.exportFailed.title"
  }),
  type: 'warning'
});
const exportClient = ExportClient();
const DEFAULT_KB_TABLE_COLUMNS = [CONTENT_PLATFORM_PROPERTY_NAME.NAME, CONTENT_PLATFORM_PROPERTY_NAME.STATE, CONTENT_PLATFORM_PROPERTY_NAME.CATEGORY_ID, CONTENT_PLATFORM_PROPERTY_NAME.UPDATED_AT, CONTENT_PLATFORM_PROPERTY_NAME.CREATED_BY_USER_ID];
const AuthorFilter = ({
  propertyDefinition
}) => {
  const {
    setQuickFilter,
    removeQuickFilter
  } = useListingLibQuickFilters();
  const getQuickFilterValue = useGetQuickFilterValue();
  const value = getQuickFilterValue(CONTENT_PLATFORM_PROPERTY_NAME.CREATED_BY_USER_ID);
  const authors = useAppSelector(selectAuthors);
  const authorsList = authors.filter(Boolean);
  const options = useMemo(() => {
    return [{
      text: I18n.text('knowledgeContentUI.quickFilters.me'),
      value: '__hs__ME',
      avatar: /*#__PURE__*/_jsx(Text, {
        as: "span",
        marginInlineEnd: "-300",
        children: /*#__PURE__*/_jsx(DynamicFilterIcon, {
          alignWithText: true
        })
      })
    }, ...authorsList.map(author => ({
      text: author.authorName,
      value: author.id.toString()
    }))];
  }, [authorsList]);
  const handleSelectCategory = useCallback(({
    currentTarget: {
      value: selectedValue
    }
  }) => {
    if (!selectedValue) {
      removeQuickFilter(CONTENT_PLATFORM_PROPERTY_NAME.CREATED_BY_USER_ID);
      return;
    }
    if (Array.isArray(selectedValue)) {
      if (selectedValue.length === 0) {
        removeQuickFilter(CONTENT_PLATFORM_PROPERTY_NAME.CREATED_BY_USER_ID);
        return;
      }
      setQuickFilter(IN(CONTENT_PLATFORM_PROPERTY_NAME.CREATED_BY_USER_ID, selectedValue));
      return;
    }
  }, [removeQuickFilter, setQuickFilter]);
  const numberOfSelectedOptions = Array.isArray(value) ? value.length : 0;
  const filterLabel = propertyDefinition.label;
  const labelText = numberOfSelectedOptions > 0 ? `${filterLabel} ${I18n.text('knowledgeContentUI.quickFilters.countOfSelectedFiltersInParentheses', {
    count: numberOfSelectedOptions
  })}` : filterLabel;
  const renderButtonContent = () => labelText;
  return /*#__PURE__*/_jsx(ListingLibFilterWrapper, {
    active: value !== null,
    children: /*#__PURE__*/_jsx(Select, {
      menuWidth: 240,
      buttonUse: "transparent",
      anchorType: "button",
      minimumSearchCount: 0,
      onChange: handleSelectCategory,
      options: options,
      ButtonContent: renderButtonContent,
      multi: true,
      value: value
    })
  });
};
const ArticleListingPage = props => {
  const {
    knowledgeBaseDetails: {
      knowledgeBase
    },
    knowledgeScopes,
    onRouteChange,
    includePrimaryLanguageInSlug,
    articlesInfo,
    primaryLanguage
  } = props;
  const [currentViewId, setCurrentViewId] = useState(VIEW_NAME_ID.ALL_ARTICLES);
  const categoriesMap = useAppSelector(selectCategoriesList);
  const {
    hasScope: canRestrictContent
  } = useHasScope(SERVICE_CONTENT_RESTRICTED_WRITE);
  const {
    hasScope: hasContactsListReadAccess
  } = useHasScope(CONTACTS_LISTS_READ);
  const {
    hasScope: hasContactsListAccess
  } = useHasScope(CONTACTS_LISTS_ACCESS);
  const {
    hasScope: canPublishArticle
  } = useHasScope(SERVICE_KNOWLEDGE_ARTICLE_PUBLISH_SCOPE);
  const canAccessLists = hasContactsListAccess || hasContactsListReadAccess;
  const canViewContentAccessControl = canRestrictContent && canAccessLists;
  const canManagePrivateContent = useAppSelector(getUserHasManagePrivateContentAccess);
  const authors = useAppSelector(selectAuthors);
  const authorsList = authors.filter(Boolean);
  const [openDialog, setCloseDialog] = useState(false);
  const toggleExportDialog = useCallback(() => {
    setCloseDialog(!openDialog);
  }, [openDialog, setCloseDialog]);
  const {
    search
  } = useLocation();
  const [showImportModal, setShowImportModal] = useState(() => {
    return new URLSearchParams(search).has('loadImportModal');
  });
  useEffect(() => {
    setShowImportModal(new URLSearchParams(search).has('loadImportModal'));
  }, [search]);
  const smartCopyProgressState = useSmartCopyProgress(knowledgeBase.id);
  const additionalKbActions = useMoreKnowledgeBaseActions({
    toggleExportDialog
  });
  const userEmail = useAppSelector(getUserEmail);
  const knowledgeBaseId = useCurrentKnowledgeBaseId();
  useEffect(() => {
    setupCsat('CSAT_SVH_KNOWLEDGEBASE');
  }, []);

  //Filter options
  const authorOptions = authorsList.map(author => {
    return {
      label: author.authorName,
      value: author.id.toString(),
      displayOrder: -1,
      hidden: false
    };
  });
  const propertyOverrides = useMemo(() => {
    return {
      standardPropertyMap: {
        [CONTENT_PLATFORM_PROPERTY_NAME.GROUP_ID]: {
          hidden: true
        },
        [CONTENT_PLATFORM_PROPERTY_NAME.DOMAIN]: {
          hidden: true
        },
        [CONTENT_PLATFORM_PROPERTY_NAME.CREATED_BY_USER_ID]: {
          hidden: false,
          label: getCustomPropertyLabel(CONTENT_PLATFORM_PROPERTY_NAME.CREATED_BY_USER_ID),
          name: CONTENT_PLATFORM_PROPERTY_NAME.CREATED_BY_USER_ID,
          type: 'enumeration',
          options: authorOptions
        },
        [CONTENT_PLATFORM_PROPERTY_NAME.AUDIENCE_ACCESS]: {
          hidden: !canViewContentAccessControl,
          //removes 'PRIVATE_PASSWORD_REQUIRED' as an option
          options: getAudienceAccessPropertyOptions().filter(options => options.value !== AudienceAccessTypes.PRIVATE_PASSWORD_REQUIRED)
        },
        [CONTENT_PLATFORM_PROPERTY_NAME.STATE]: {
          //removes 'SCHEDULED' as an option
          hidden: false,
          options: getContentPublishStatusPropertyOptions().filter(options => options.value !== FilterablePublishStates.SCHEDULED)
        }
      },
      customPropertyMap: {
        //CategoriesFilter
        hs_knowledge_category_name: {
          hidden: false,
          label: getCustomPropertyLabel('hs_knowledge_category_name'),
          name: 'hs_knowledge_category_name',
          type: 'enumeration'
        }
      }
    };
  }, [authorOptions, canViewContentAccessControl]);
  const propertyFilterConfigs = useMemo(() => {
    return {
      [CONTENT_PLATFORM_PROPERTY_NAME.STATE]: {
        hidden: false,
        hasQuickFilter: true
      },
      [CONTENT_PLATFORM_PROPERTY_NAME.CREATED_BY_USER_ID]: {
        hidden: false,
        hasQuickFilter: true
      },
      [CONTENT_PLATFORM_PROPERTY_NAME.CREATED_BY_USER_ID]: {
        hidden: false,
        hasQuickFilter: true
      },
      [CONTENT_PLATFORM_PROPERTY_NAME.AUDIENCE_ACCESS]: {
        hidden: !canViewContentAccessControl,
        hasQuickFilter: !!canViewContentAccessControl
      },
      [CONTENT_PLATFORM_PROPERTY_NAME.STATE]: {
        hidden: false,
        hasQuickFilter: true
      },
      //CategoriesFilter
      hs_knowledge_category_name: {
        hidden: false,
        hasQuickFilter: true,
        label: getCustomPropertyLabel('hs_knowledge_category_name'),
        fieldDefinition: {
          operators: OrderedSet.of(In, NotIn)
        }
      },
      hs_campaign: {
        hidden: false,
        hasQuickFilter: true,
        label: getCustomPropertyLabel('hs_campaign'),
        fieldDefinition: {
          operators: OrderedSet.of(In, NotIn)
        }
      }
    };
  }, [canViewContentAccessControl]);
  const propertyTableColumnConfigs = useMemo(() => {
    return {
      hs_knowledge_category_name: {
        renderCell: tableProps => {
          const categoryName = getContentPropertyValue(tableProps.crmObject, 'hs_knowledge_category_name', '');
          const subcategoryName = getContentPropertyValue(tableProps.crmObject, 'hs_knowledge_subcategory_name', '');
          return /*#__PURE__*/_jsx(TFlex, {
            direction: "column",
            children: /*#__PURE__*/_jsx("div", {
              "aria-label": categoryName,
              children: /*#__PURE__*/_jsxs("span", {
                "aria-hidden": true,
                children: [categoryName && /*#__PURE__*/_jsx(TruncateString, {
                  children: categoryName
                }), subcategoryName && /*#__PURE__*/_jsx(Small, {
                  use: "help",
                  "aria-label": subcategoryName,
                  children: /*#__PURE__*/_jsx(TruncateString, {
                    children: subcategoryName
                  })
                })]
              })
            })
          });
        }
      }
    };
  }, []);
  const trackerProps = {
    applicationId: 'knowledge-content-ui',
    tracker: usageTrackerForFrameworkListingLib
  };
  const tableProps = {
    renderErrorMarker: () => /*#__PURE__*/_jsx(NavMarker, {
      name: "MANAGE_ERROR"
    }),
    renderSuccessMarker: () => /*#__PURE__*/_jsx(NavMarker, {
      name: "V3_ARTICLES_LOADED"
    }),
    hasBulkActions: true,
    hasContentPreviewPanel: false,
    CustomEmptyState: ArticleTableEmptyState,
    //Verify if the current View is All Articles (default)
    additionalTableActions: currentViewId === VIEW_NAME_ID.ALL_ARTICLES ? additionalKbActions : undefined
  };
  const authInfo = useSelector(getAuth);
  const currentKnowledgeBaseId = useCurrentKnowledgeBaseId();
  const hiddenFilter = useMemo(() => {
    return {
      filterGroups: [{
        filters: [{
          operator: 'IN',
          property: CONTENT_PLATFORM_PROPERTY_NAME.GROUP_ID,
          values: [currentKnowledgeBaseId]
        }]
      }]
    };
  }, [currentKnowledgeBaseId]);
  const isKnowledgeBasePrivate = knowledgeBase.isKnowledgeBasePrivate;
  const knowledgeBaseAccessType = knowledgeBase.scpValues ? knowledgeBase.scpValues.hs_access_rule_type : undefined;
  const accessControlOptions = getContentAccessControlOptions({
    knowledgeBaseAccessType,
    isKnowledgeBasePrivate
  });

  //#region Article Action configuration
  const EditConfig = {
    id: CONTENT_ACTION_IDS.EDIT,
    enablePermissions: {
      scopes: ['content-editor-access']
    },
    tableRowActionGroup: ROW_ACTION_GROUPS.BASIC,
    displayPermissions: {
      scopes: [SERVICE_KNOWLEDGE_ARTICLE_WRITE_SCOPE]
    },
    onActionButtonClick(article) {
      const articleId = getContentPropertyValue(article, CONTENT_PLATFORM_PROPERTY_NAME.ID);
      window.location.href = getEditorUrl(articleId);
    }
  };
  const ViewConfig = {
    id: CONTENT_ACTION_IDS.VIEW,
    name: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "knowledgeContentUI.shared.actions.view"
    }),
    tableRowActionGroup: ROW_ACTION_GROUPS.BASIC,
    displayPermissions: {
      custom: ({
        crmObjects
      }) => {
        const article = crmObjects[0];
        const state = getContentPropertyValue(article, 'hs_state');
        return state !== StateConstants.DRAFT;
      }
    },
    onActionButtonClick(article) {
      const url = getContentPropertyValue(article, 'hs_absolute_url');
      if (url) {
        window.location.href = url;
      }
    }
  };
  const DetailsConfig = {
    id: CONTENT_ACTION_IDS.DETAILS,
    onActionButtonClick(article) {
      const contentId = getContentPropertyValue(article, CONTENT_PLATFORM_PROPERTY_NAME.ID);
      window.location.href = getArticlePerformanceUrl(contentId);
    }
  };
  const DeleteLangGroupConfig = {
    id: CONTENT_ACTION_IDS.DELETE_LANGUAGE_GROUP,
    tableRowActionGroup: ROW_ACTION_GROUPS.MULTI_LANG,
    displayPermissions: {
      scopes: [SERVICE_KNOWLEDGE_ARTICLE_WRITE_SCOPE]
    }
  };
  const AddLangGroupConfig = {
    id: CONTENT_ACTION_IDS.ADD_TO_LANGUAGE_GROUP,
    tableRowActionGroup: ROW_ACTION_GROUPS.MULTI_LANG,
    displayPermissions: {
      scopes: [SERVICE_KNOWLEDGE_ARTICLE_WRITE_SCOPE]
    }
  };
  const CreateLangVariantConfig = {
    id: CONTENT_ACTION_IDS.CREATE_LANGUAGE_VARIANT,
    tableRowActionGroup: ROW_ACTION_GROUPS.MULTI_LANG,
    displayPermissions: {
      scopes: [SERVICE_KNOWLEDGE_ARTICLE_WRITE_SCOPE]
    }
  };
  const ClonePermissionsConfig = {
    id: CONTENT_ACTION_IDS.CLONE,
    displayPermissions: {
      scopes: [SERVICE_KNOWLEDGE_ARTICLE_WRITE_SCOPE]
    }
  };
  const AudienceAccessConfig = {
    id: CONTENT_ACTION_IDS.CONTROL_AUDIENCE_ACCESS,
    tableRowActionGroup: ROW_ACTION_GROUPS.STATE_ACTIONS,
    enablePermissions: {
      custom: () => !!(canViewContentAccessControl && canManagePrivateContent)
    },
    DisabledTooltipContent: () => /*#__PURE__*/_jsx(FormattedMessage, {
      message: getContentAccessControlEditPermissionsDisabledTooltipI18nKey(ContentTypes.KNOWLEDGE_ARTICLE)
    }),
    ModalOrPanel: accessProps => {
      return /*#__PURE__*/_jsx(AsyncContentAccessControlPanel, Object.assign({}, accessProps, {
        userCanViewContentAccessControl: canViewContentAccessControl,
        userHasManagePrivateContentAccess: canManagePrivateContent,
        userHasContentTypePublishAccess: canPublishArticle,
        accessControlContentType: ContentTypes.KNOWLEDGE_ARTICLE,
        accessControlOptions: accessControlOptions
      }));
    },
    displayPermissions: {
      custom: () => !!canViewContentAccessControl
    }
  };
  const ArchiveArticleConfig = {
    id: CONTENT_ACTION_IDS.ARCHIVE,
    tableRowActionGroup: ROW_ACTION_GROUPS.STATE_ACTIONS,
    displayPermissions: {
      scopes: [SERVICE_KNOWLEDGE_ARTICLE_PUBLISH_SCOPE]
    }
  };
  const DeleteArticleConfig = {
    id: CONTENT_ACTION_IDS.DELETE,
    tableRowActionGroup: ROW_ACTION_GROUPS.STATE_ACTIONS,
    displayPermissions: {
      scopes: [SERVICE_KNOWLEDGE_ARTICLE_PUBLISH_SCOPE]
    }
  };
  const ArticlePublishingConfig = {
    id: CONTENT_ACTION_IDS.PUBLISHING_OPTIONS,
    tableRowActionGroup: ROW_ACTION_GROUPS.STATE_ACTIONS,
    ModalOrPanel: modalProps => {
      const {
        hasGate
      } = useHasGate(gate('KnowledgeBase:LifecycleManagement'));
      return /*#__PURE__*/_jsx(AsyncPublishingOptionsModal, Object.assign({}, modalProps, {
        membershipsContentType: ContentTypes.KNOWLEDGE_ARTICLE,
        canSchedule: hasGate
      }));
    },
    displayPermissions: {
      scopes: [SERVICE_KNOWLEDGE_ARTICLE_PUBLISH_SCOPE]
    }
  };
  const ArticleUnpublishingConfig = {
    id: CONTENT_ACTION_IDS.UNPUBLISHING_OPTIONS,
    tableRowActionGroup: ROW_ACTION_GROUPS.STATE_ACTIONS,
    ModalOrPanel: modalProps => {
      const {
        hasGate
      } = useHasGate(gate('KnowledgeBase:LifecycleManagement'));
      return /*#__PURE__*/_jsx(AsyncUnpublishingOptionsModal, Object.assign({}, modalProps, {
        canSchedule: hasGate,
        allowRedirectionOnUnpublish: false
      }));
    },
    displayPermissions: {
      scopes: [SERVICE_KNOWLEDGE_ARTICLE_PUBLISH_SCOPE]
    }
  };
  const RunTestConfig = {
    id: CONTENT_ACTION_IDS.RUN_A_TEST,
    displayPermissions: {
      custom: () => false
    }
  };
  const AssignPermissionsConfig = {
    id: CONTENT_ACTION_IDS.ASSIGN_PERMISSIONS,
    displayPermissions: {
      custom: () => false
    }
  };
  const handleActionError = useCallback(({
    actionId,
    data,
    bulkActionErrorDetailsModalButton
  }) => {
    switch (actionId) {
      case 'controlAudienceAccess':
        {
          FloatingAlertStore.addAlert(getContentAccessControlPanelSaveFailureNotification({
            contentCategoryId: CATEGORY_IDS.KNOWLEDGE_BASE_ILP,
            contentCount: data.failedResults.length
          }));
          break;
        }
      case 'publishingOptions':
        {
          if (data !== null && data !== void 0 && data.failedResults && data.failedResults.length > 0) {
            FloatingAlertStore.addAlert({
              titleText: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "knowledgeContentUI.shared.publishing.validation.error.title",
                options: {
                  count: data.failedResults.length
                }
              }),
              message: bulkActionErrorDetailsModalButton,
              type: 'danger'
            });
          }
          break;
        }
      default:
        break;
    }
  }, []);
  const handleActionSuccess = useCallback(({
    actionId,
    data
  }) => {
    switch (actionId) {
      case 'archive':
      case 'delete':
        if (data.completedResults.some(article => article.properties['hs_state'].value === StateConstants.PUBLISHED)) {
          UsageTracker.track('articleRemovalPublished', {
            action: actionId === 'archive' ? 'archived' : 'deleted',
            screen: SCREENS.MANAGE
          });
        } else {
          UsageTracker.track('articleRemovalDraft', {
            action: actionId === 'archive' ? 'archived' : 'deleted',
            screen: SCREENS.MANAGE
          });
        }
        break;
      case 'publishingOptions':
        UsageTracker.track('publishedOrUpdatedArticle', {
          screen: SCREENS.MANAGE,
          action: data.completedResults.some(article => article.properties['hs_state'].value !== StateConstants.PUBLISHED) ? 'published' : 'updated'
        });
        break;
      case 'unarchive':
        UsageTracker.track('articleRemovalDraft', {
          action: 'unarchived',
          screen: SCREENS.MANAGE
        });
        break;
      case 'unpublishingOptions':
        UsageTracker.track('articleRemovalPublished', {
          action: 'unpublished',
          screen: SCREENS.MANAGE
        });
        break;
      case 'controlAudienceAccess':
        {
          var _data$actionData;
          const publicAccessRuleType = data === null || data === void 0 || (_data$actionData = data.actionData) === null || _data$actionData === void 0 ? void 0 : _data$actionData.accessRuleType;
          if (publicAccessRuleType) {
            FloatingAlertStore.addAlert(getContentAccessControlPanelSaveSuccessNotification({
              contentCategoryId: CATEGORY_IDS.KNOWLEDGE_BASE_ILP,
              contentCount: data.completedResults.length,
              publicAccessRuleType
            }));
          }
          break;
        }
      default:
        break;
    }
  }, []);
  // #endregion

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ProvideContentReferenceResolvers, {
      children: /*#__PURE__*/_jsx(ContentListingLibProvider, {
        defaultTableColumns: DEFAULT_KB_TABLE_COLUMNS,
        contentObjectType: ContentObjectTypes.KNOWLEDGE_ARTICLE,
        contentGroupObjectType: ContentGroupObjectTypes.KNOWLEDGE_BASE,
        propertyOverrides: propertyOverrides,
        propertyFilterConfigs: propertyFilterConfigs,
        filterValidationConfig: filterValidationConfig,
        hasViews: true,
        currentViewId: currentViewId,
        trackerProps: trackerProps,
        savedViewsNamespace: Namespaces.KNOWLEDGE_ARTICLES,
        onViewIdChange: viewId => setCurrentViewId(String(viewId)),
        authInfo: {
          userInfo: authInfo
        },
        hiddenFilter: hiddenFilter,
        emptyStateFilter: hiddenFilter,
        actionsConfigOptions: {
          onActionError: handleActionError,
          onActionSuccess: handleActionSuccess,
          actionSuccessHandlerOverrides: {},
          actionsConfigOverrides: [RunTestConfig, AssignPermissionsConfig, EditConfig, ViewConfig, DetailsConfig, AudienceAccessConfig, AddLangGroupConfig, DeleteLangGroupConfig, CreateLangVariantConfig, ArchiveArticleConfig, DeleteArticleConfig, ArticlePublishingConfig, ArticleUnpublishingConfig, ClonePermissionsConfig]
        },
        children: /*#__PURE__*/_jsxs(ListingPage, {
          "data-test-id": "manage-articles",
          headerComponent: /*#__PURE__*/_jsx(Header, {
            knowledgeScopes: knowledgeScopes,
            onRouteChange: onRouteChange,
            selectedTab: 'manage',
            includePrimaryLanguageInSlug: includePrimaryLanguageInSlug,
            primaryLanguage: primaryLanguage,
            knowledgeBase: knowledgeBase,
            screen: 'manage-articles'
          }),
          children: [/*#__PURE__*/_jsx(UpgradeDowngradeBanner, {
            currentArticleCount: articlesInfo.totalCount
          }), /*#__PURE__*/_jsx(ImportArticlesPanel, {}), /*#__PURE__*/_jsxs("div", {
            style: {
              position: 'relative'
            },
            children: [isInProgress(smartCopyProgressState) && /*#__PURE__*/_jsx(LoadingOverlay, {
              contextual: true,
              label: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "knowledgeContentUI.importArticles.loadingLabel"
              }),
              layout: "centered",
              showLabel: true
            }), /*#__PURE__*/_jsx(ContentQuickFilters, {
              customQuickFilterComponentsByProperty: {
                hs_knowledge_category_name: () => /*#__PURE__*/_jsx(ArticleCategoryFilter, {
                  categories: categoriesMap
                }),
                hs_campaign: () => /*#__PURE__*/_jsx(ArticlesCampaignFilter, {}),
                [CONTENT_PLATFORM_PROPERTY_NAME.CREATED_BY_USER_ID]: AuthorFilter
              }
            }), /*#__PURE__*/_jsx(ContentListingTable, Object.assign({}, tableProps, {
              propertyTableColumnConfigs: propertyTableColumnConfigs
            }))]
          })]
        })
      })
    }), openDialog && /*#__PURE__*/_jsx(ExportDialog, {
      client: {
        export: opts => exportClient.export(Object.assign({}, opts, {
          knowledgeBaseId
        }))
      },
      onClose: toggleExportDialog,
      userEmail: userEmail,
      onSuccess: onSuccess,
      onFailure: onFailure
    }), showImportModal && /*#__PURE__*/_jsx(ImportModal, {
      onClose: () => setShowImportModal(false)
    })]
  });
};
export default ArticleListingPage;